import { Controller } from "@hotwired/stimulus"

// Under the AI's notes on a site walk (#12 on the Site Walks list: "AI
// progress per area, and what changed"): where the work stands in each area,
// and what changed since the walk before it on the job. Filled when the
// viewer opens a walk - site_walks_controller.js dispatches site-walks:opened
// on window with { walk, video } - and emptied when it closes. Each block
// stays hidden when there is nothing to say. The AI's words go in as text,
// never as HTML.
export default class extends Controller {
  static targets = ["areasBlock", "areasList", "changesBlock", "changesTitle", "changesList"]
  static values = { text: Object }

  show(event) {
    this.hide()
    const walk = event.detail?.walk
    if (!walk) return

    // [{ name, progress }] - "Lobby: Drywall is hung and taped."
    const areas = (Array.isArray(walk.ai_areas) ? walk.ai_areas : [])
      .filter((area) => this._said(area?.name) && this._said(area?.progress))
    areas.forEach((area) => {
      const item = document.createElement("li")
      const name = document.createElement("span")
      name.className = "font-semibold text-gray-900"
      name.textContent = `${area.name.trim()}:`
      item.append(name, ` ${area.progress.trim()}`)
      this.areasListTarget.append(item)
    })
    this.areasBlockTarget.hidden = areas.length === 0

    // One sentence a line, under "What changed since Sep 18 · Canal road".
    const changes = this._said(walk.ai_changes)
      ? walk.ai_changes.split("\n").map((line) => line.trim()).filter(Boolean)
      : []
    changes.forEach((line) => {
      const item = document.createElement("li")
      item.textContent = line
      this.changesListTarget.append(item)
    })
    const since = this._said(walk.ai_changes_since) ? walk.ai_changes_since.trim() : null
    this.changesTitleTarget.textContent = since
      ? (this.textValue.changes_since || "What changed since __SINCE__").replace("__SINCE__", () => since)
      : (this.textValue.changes || "What changed since the last walk")
    this.changesBlockTarget.hidden = changes.length === 0
  }

  hide() {
    this.areasListTarget.replaceChildren()
    this.changesListTarget.replaceChildren()
    this.changesTitleTarget.textContent = ""
    this.areasBlockTarget.hidden = true
    this.changesBlockTarget.hidden = true
  }

  _said(value) {
    return typeof value === "string" && value.trim() !== ""
  }
}
